import styled from "styled-components";
import { motion } from "framer-motion";
import { TimelineConnector, TimelineDot } from "@mui/lab";
import { COLORS } from "../../../../../values/colors";
import { Paragraph } from "../../../../../lib/Font/styles";

export const Container = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
  box-sizing: border-box;

  @media (max-width: 1450px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  @media (max-width: 620px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const ImageContainer = styled(motion.div)`
  flex: 1;
  overflow: hidden;
  position: relative;
  border-radius: 1.5rem;
  z-index: 1;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
  margin-bottom: 7.5rem;
  height: 20rem;
  width: 35rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 2.5s ease;
  }

  img:hover {
    transform: scale(1.1);
  }

  @media (max-width: 1450px) {
    width: 100%;
    height: 14rem;
  }
`;

export const Heading = styled(motion.h1)`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  @media (max-width: 1450px) {
  font-size: 1.25rem;
}
`;

export const CustomTimeLineDot = styled(TimelineDot)`
  background-color: ${COLORS.apronBrown} !important;
  height: 0.75rem;
  width: 0.75rem;

  @media (max-width: 1450px) {
    height: 0.6rem;
    width: 0.6rem;
  }
`;

export const CustomTimelineConnector = styled(TimelineConnector)`
`;

export const StyledParagraph = styled(Paragraph)`
  color: ${COLORS.textSecondary};
  font-size: 1rem;

  @media (max-width: 1450px) {
    font-size: 0.85rem;
  }
`;

export const ContentWrapperLeft = styled.div`
  padding-right: 4rem;

  @media (max-width: 1450px) {
    padding-right: 2rem;
  }

  @media (max-width: 768px) {
    padding-right: 0;
  }
`;

export const ContentWrapperRight = styled.div`
  padding-left: 4rem;

  @media (max-width: 1450px) {
    padding-left: 2rem;
  }

  @media (max-width: 768px) {
    padding-left: 0;
  }
`;
